/**
 * Returns true if the given element is one where the user is likely typing:
 * input, textarea, contentEditable, textbox role, or a ProseMirror editor.
 */
export function isEditableElement(element: EventTarget | Element | null): boolean {
  if (!element || !(element instanceof HTMLElement)) return false;

  const tagName = element.tagName.toLowerCase();
  if (tagName === "input" || tagName === "textarea") return true;

  if (element.isContentEditable) return true;

  if (element.getAttribute("role") === "textbox") return true;

  if (element.closest(".ProseMirror")) return true;

  return false;
}
